import { render } from "./GPTsGridComponent.vue?vue&type=template&id=66c1113f"
import script from "./GPTsGridComponent.vue?vue&type=script&lang=js"
export * from "./GPTsGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__